export default class UserNotLoggedInError extends Error {
    constructor(message) {
        super(message)
        this.name = "UserNotLoggedInError"
    }
}